<!--
 * @Date: 2021-07-26 13:50:52
 * @LastEditTime: 2021-07-30 17:33:46
 * @Description: 电商企业详情页
 * @FilePath: \shangwu_web\src\views\demonstration\pages\detailPage.vue
-->
<template>
<div class="detailInfo">
  <web-head :active="tab" @change="changeTab"></web-head>
  <div class="background type-page">
    <article class="contain flex-column-center">
      <section class="location"><span>您现在的位置是：<span @click="navPosition('home')" class="navPosition">首页</span>> <span @click="navPosition('serverHome')" class="navPosition">服务资源</span>> 服务商详情</span></section>
      <!-- 公司头部信息 -->
      <section class="info">
        <div class="info-main flex-row-center-end-space-between">
          <div class="info-img"><img :src="demonstrationNew.logo" alt=""></div>
          <div class="info-detail">
            <div class="i-d-name" v-html="demonstrationNew.enterpriseName"><span>诚信承诺企业</span></div>
            <div class="i-d-line"></div>
            <div class="i-d-item flex-row-center-left"><img src="@imgs/pages/demonstration/person.png" alt=""><span>联系人：</span><span>{{demonstrationNew.mainPerson}}</span></div>
            <div class="i-d-item flex-row-center-left"><img src="@imgs/pages/demonstration/phone1.png" alt=""><span>电话：</span><span>{{demonstrationNew.telephone}}</span></div>
            <div class="i-d-item flex-row-center-left"><img src="@imgs/pages/demonstration/email.png" alt=""><span>邮箱：</span><span>{{demonstrationNew.email}}</span></div>
            <div class="i-d-item flex-row-center-left"><img src="@imgs/pages/demonstration/phone2.png" alt=""><span>手机：</span><span>{{demonstrationNew.mainPersonMobile}}</span></div>
            <div class="i-d-item flex-row-center-left"><img src="@imgs/pages/demonstration/adress.png" alt=""><span class="addresstitle">地址：</span><span class="address">{{demonstrationNew.address}}</span></div>
          </div>
          <div class="info-button">
            <a id="button1" :href='demonstrationNew.commitment' v-show="demonstrationNew.commitment">立即联系</a>
          </div>
        </div>
      </section>
      <!-- 公司详细信息 -->
      <section class="detail flex-column-center">
        <div class="introductory flex-column-center">
          <div class="d-top flex-row-center-end-space-between">
            <div>公司简介</div>
          </div>
          <div v-html="demonstrationNew.introduction" class="content">
          </div>
        </div>
        <div class="products">
          <div class="d-top flex-row-center-end-space-between">
            <div>已完成需求</div>
          </div>
          <div class="products-show">
            <div class="swiper-container swiperProducts" v-if="productsList.length">
              <div class="swiper-wrapper">
                  <div :title="item.title"
                       :key="item.id" 
                       v-for="item in productsList" 
                       class="swiper-slide p-s-box" @click="navtoGood(item.id)">
                    <div class="p-s-img"><img :src="item.images" alt=""></div>
                    <div class="p-s-title" v-html="item.title"></div>
                  </div>
              </div>
            </div>
            <div v-else>
              暂无
            </div>
          </div>
        </div>
      </section>
    </article>
  </div>
  <web-foot></web-foot>
</div>
</template>

<script scoped>
import {demonstration,demonstrationGoods,getPVUV} from '@apis/apis'
import Head from '@wigets/head.vue'
import Foot from '@wigets/foot.vue'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'

export default {
  name:"detailPages",
  data(){
    return{
      tab:2,
      checked:1,
      serviceList:[],
      productsList:[
      ],
      demonstrationNew:{}
    }
  },
  created () {
    this.getdemonstration();
    this.getpvuv()

  },
  mounted(){
    this.renderProducts()
  },
  methods:{
    //埋点
    getpvuv(){
      this.$ajaxPost(getPVUV,{
        ip: sessionStorage.getItem('ip'),
        directoryOne: "服务体系",
        directoryTwo: "服务资源",
        directoryThree: "服务详情",
        cookie: sessionStorage.getItem('random')
      })
    },
    //点击位置导航进行跳转
    navPosition(name){
      if(name=='serverHome'){
        this.$router.push({name,checked:3})
      }else{
        this.$router.push({name})
      }
    },
    changeTab(val) {
      this.tab = val
    },

    productsTab(key){
      this.checked = key
    },
    /**
     * @description: 进入页面获取的企业信息
     * @param {*}
     */
    navtoGood(id){
      this.$router.push({name:'preferredNews',query:{id}})
    },
    /**
     * @description: 进入页面获取的企业信息
     * @param {*}
     */
    getdemonstration(){
      if(!this.$route.query.id){
        return this.$route.push({name:'services'})
      }
      let id=this.$route.query.id;
      this.$ajaxGet(`${demonstration}/${id}`).then(res => {
        if (res.data.code != 0) {
          this.$message({
            title: "错误",
            type: "error",
            message: res.data.msg + ",请重新刷新",
          })
        } else {
          this.demonstrationNew = res.data.data
          this.demonstrationNew.introduction=this.showcontent(this.demonstrationNew.introduction)
        }
      }).catch(err => {
        this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
          confirmButtonText: '确定',
          type: "error",
          callback: () => {
            location.reload()
          }
        })
      })
    },

    /**
     * @description: 进入页面获取的企业商品
     * @param {*}
     */
    getdemonstrationGood(){
      if(!this.$route.query.id){
        return this.$route.push({name:'Demonstration'})
      }
      let id=this.$route.query.id;
      this.$ajaxGet(`${demonstrationGoods}/${id}`).then(res => {
        if (res.data.code != 0) {
          this.$message({
            title: "错误",
            type: "error",
            message: res.data.msg + ",请重新刷新",
          })
        } else {
          this.productsList = res.data.data
        }
      }).catch(err => {
        this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
          confirmButtonText: '确定',
          type: "error",
          callback: () => {
            location.reload()
          }
        })
      })
    },

    /**
     *  内容转义
     * @param {*}
     * @param {*} 
     */
    showcontent(str) {
      if(!str){
        return
      }
      let arrEntities={'lt':'<','gt':'>','nbsp':' ','amp':'&','quot':'"'};
      return str.replace(/&(lt|gt|nbsp|amp|quot);/ig,function(all,t){
        return arrEntities[t];
      });
    },


    renderProducts() {
      new Swiper ('.swiperProducts', {
        slidesPerView : 4,
        spaceBetween : 20,
        observer:true,
        observeParents: true,
        preventClicks: false,
      })
    },
  },

  components: {
    'web-head': Head,
    'web-foot': Foot,
  }
}
  
</script>

<style lang="less" scoped>
.detailInfo{
  @media all and (min-width:750px){
    .background{
      background-color: #f2f2f2;
      padding-bottom: .50rem;
    }
    .contain{
      width: 100%; 
      margin: 0rem auto;
      position: relative;

      section{
        width: 100%;
        margin-top: .20rem;
      }

      .location{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        font-size: .14rem;
        letter-spacing: 0rem;
        color: #aaaaaa;
      }

      // 公司头部信息
      .info{
        width: 100%;
        background-color: #ffffff;
        border-radius: .06875rem;
        display: flex;
        justify-content: center;
        align-items: center;
        .info-main{
          padding: 0 .171875rem;
          width: 100%;
          height: 3rem;
          justify-content: flex-start;
          align-items: center;
          box-sizing: border-box;
          .info-img{
            display: flex;
            width: 2.50rem;
            height: 2.50rem;
            background-color: #ffffff;
            box-shadow: 0rem .03rem .15rem 0rem 
              rgba(77, 150, 242, 0.35);
            border-radius: .10rem;
            margin-right: 0.5rem;
            overflow: hidden;
            align-items: center;
            img{
              width: 100%;
            }
          }
        }
        .info-detail{
          width: 6.50rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: flex-start;
          .i-d-name{
            height: .4125rem;
            line-height: .4125rem;
            font-size: .171875rem;
            font-weight: bold;
            color: #333333;
            text-align: left;
            span{
              display: inline-block;
              width: 1.06rem;
              height: .20rem;
              margin-left: .12rem;
              border-radius: .10rem;
              border: solid 1px #4982dc;
              font-size: .13rem;
              font-weight: normal;
              line-height: .48rem;
              letter-spacing: 0rem;
              color: #4982dc;
              white-space: nowrap;
              padding: 0.05rem 0.1rem;
            }
          }
          .i-d-line{
            width: 5.00rem;
            height:1px;
            background-color: #dcdcdc;
          }
          .i-d-item{
            width: 100%;
            span:nth-of-type(1){
              color: #999;
              margin-right: 0;
            }
            span:nth-of-type(2){
              margin-left: 0;
            }
            .addresstitle{
              white-space: nowrap;
            }
            .address{
                line-height: 0.21rem;
                text-align: left;
                margin-left: 0;
              }
            img{
              width: .18rem;
              height: .20rem;
            }
            span{
              margin-left: .15rem;
              font-size: .154687rem;
              line-height: .42rem;
              letter-spacing: 0rem;
              color: #666666;
            }
            
          }
          
        }
        .info-button{
          margin-bottom: .171875rem;
          align-self: flex-end;
          width: 1.03125rem;
          height: .34375rem;
          a{
            width: 100%;
            height: 100%;
            text-decoration: none;
          }
        }
        #button1{
          
          display: block;
          background-image: linear-gradient(90deg, 
            #e95252 0%, 
            #cf2828 100%);
          border-radius: .06875rem;
          font-size: .16rem;
          line-height: .34375rem;
          color: #fefefe;
          cursor: pointer;
          
        }
        #button1:hover{opacity: 0.8;}
        #button2{
          display: block;
          width: 1.86rem;
          height: .50rem;
          margin-top: .30rem;
          background-image: linear-gradient(90deg, 
            #4d96f2 0%, 
            #316fee 100%);
          border-radius: .10rem;
          font-size: .16rem;
          line-height: .48rem;
          letter-spacing: 0rem;
          color: #fefefe;
          cursor: pointer;
          :hover{opacity: 0.6;}
        }
        #button2:hover{opacity: 0.8;}
      }

      // 公司详细信息
      .detail{
        padding: .171875rem;
        width: 100%;
        background-color: #ffffff;
        border-radius: .06875rem;
        font-size: 0.24rem;
        text-align: left;
        box-sizing: border-box;
        .content{
          padding-top:0.2rem ;
            /deep/p{
              margin: 0;
              font-size: 0.18rem;
            }
          }
        .d-top{
          width: 100%;
          margin-top: .30rem;
          border-bottom: 2px solid #dcdcdc;;
          div{
            font-size: .189062rem;
            letter-spacing: 0rem;
            line-height: .50rem;
            color: #444444;
            border-bottom: 2px solid #397aef;
            margin-bottom:-2px;
          }
          span{
            line-height: .40rem;
            font-size: .15rem;
            color: #4982dc;
            cursor: pointer;
          }
        }
        // 公司简介
        .introductory{
          width: 100%;

          .i-basic{
            width: 100%;
            margin-top: .20rem;
            img{
              width: 10.00rem;
              height: 4.61rem; 
            }
            p{
              text-align: left;
              font-size: .18rem;
              line-height: .36rem;
              color: #333333;
            }

          }
          .i-honor{
            width: 100%;
            text-align: left;
            font-size: .18rem;
            line-height: .36rem;
            color: #333333;
            .i-h-top{
              margin: .20rem 0;
              text-align: left;
              border-left: .06rem solid #4982dc;
              font-size: .20rem;
              font-weight: bold;
              color: #333333;
              span{margin-left: .15rem;}
            }
          }
        }

        // 产品服务
        .products{
          width: 100%;
          margin-top: .50rem;
          margin-bottom: .40rem;
          .p-device{
            width: 100%;
            margin-top: .20rem;
          }
          .p-d-item{
            width: 1.20rem;
            height: .24rem;
            margin-right: .20rem;
            font-size: .18rem;
            line-height: .24rem;
            color: #333333;
            cursor: pointer;
          }
          .p-d-item-active{
            width: 1.20rem;
            height: .24rem;
            background-color: #d3e3f6 !important;
            border-radius: .05rem;
            opacity: 0.7;
            color: #4982dc;
          }
          .products-show{
            width: 100%;
            height: 3.25rem;
            margin-top: .25rem;
            .p-s-box:hover{
              cursor: pointer;
              img{
                -webkit-transform: scale(1.2);
                transform: scale(1.2);
                transition: all 0.5s;
                -webkit-transition: all 0.5s; /* Safari */
                overflow: hidden;
              }
              color: #4982dc !important;
            }
            .p-s-box{
              width: 2.70rem;
              height: 3.25rem;

              .p-s-img{
                width: 100%;
                height: 2.71rem;
                border-radius: .10rem;
                border: solid 1px #d3e3f6;
                overflow: hidden;
                img{
                  width: 100%;
                  height: 100%;
                  object-fit: scale-down;
                }
              }
              .p-s-title{
                width: 100%;
                font-size: .18rem;
                line-height: .27rem;
                color: #333333;
              }
            }

          }
        }
        
      }
    }
  }
}
</style>